
 function variantBoxSlider(parentSwiper) {            
    document.querySelectorAll('.card-variant-box').forEach((box) => {
        const swiperElP = box.querySelector('swiper-container');

        if (!swiperElP || swiperElP.classList.contains('swiper-initialized')) {
            return;
        }

        // Find next & prev buttons inside the current .card-variant-box
        const nextBtn = box.querySelector('.next-btn');
        const prevBtn = box.querySelector('.prev-btn');

        Object.assign(swiperElP, {
            slidesPerView: 1,
            spaceBetween: 5,
            pagination: false,
            navigation: {
                nextEl: nextBtn,
                prevEl: prevBtn,
            },
            loop: false,
            breakpoints: {
                0: {
                    slidesPerView: 1,
                    spaceBetween: 5
                },
                420: {
                    slidesPerView: 2,
                    spaceBetween: 5
                },
                640: {
                    slidesPerView: 2,
                    spaceBetween: 5
                },
                750: {
                    slidesPerView: 3,
                    spaceBetween: 5
                },
                1199: {
                    slidesPerView: 3,
                    spaceBetween: 5
                },
                1300: {
                    slidesPerView: 3,
                    spaceBetween: 5
                }
            }
        });

        swiperElP.initialize();
        swiperElP.classList.add('swiper-initialized');

        // Stop parent slider from moving during child slider swipe
        swiperElP.addEventListener('touchstart', (event) => {
            event.stopPropagation(); // Prevent parent slider from starting to swipe
        });

        swiperElP.addEventListener('pointerdown', (event) => {
            event.stopPropagation(); // Also handle desktop (mouse) interactions
        });
    });
}

(function() {
variantBoxSlider();
})();
if (Shopify.designMode) {
        document.addEventListener('shopify:section:load', function(event) {
            variantBoxSlider();
        });
    }

//readmore-less description
const desc = document.querySelector(".metafield-multi_line_text_field");

if (desc) {
  const fullText = desc.textContent.trim();
  const limit = 100;

  if (fullText.length > limit) {
    const shortText = fullText.substring(0, limit) + "...";
    let isShort = true;

    function updateText() {
      desc.innerHTML = isShort
        ? shortText + ' <strong>Mehr lesen</strong>'
        : fullText + ' <strong>Weniger lesen</strong>';
    }

    updateText();

    desc.addEventListener("click", () => {
      isShort = !isShort;
      updateText();
    });
  }
}
  
// const var_Input = document.querySelector(".link_card");
// const var_Option = document.querySelector(".card-variant-box-wrapper");

// if (var_Input && var_Option) {
//   var_Input.addEventListener("click", () => {
//     var_Option.style.display = "block";
//   });
// }

//sub collection slider
 var swiper = new Swiper(".collection_page_custom",{
    slidesPerView: 8,
    spaceBetween: 25,
    loop: false,
    navigation:{
      nextEl:".swiper-button-next",
      prevEl:".swiper-button-prev"
    },
     breakpoints:{
       0: {
               slidesPerView:2.2,
               spaceBetween: 10
            },  
         750: {
               slidesPerView:3.5,
               spaceBetween: 20
            },
         990: {
               slidesPerView:5.5,
               spaceBetween: 20
            },
         1200: {
            slidesPerView: 8,
          }
        }
  });

document.addEventListener("DOMContentLoaded", function () {
    var swiperWrapper = document.querySelector(".collection_page_custom .swiper-wrapper");
        if (swiperWrapper) {
        var slides = swiperWrapper.querySelectorAll(".swiper-slide");
                if (slides.length > 8) {
            swiperWrapper.classList.add("custom_swipe_slies");
        }
    }
});

// function checkCartPrice() {
//     var checkoutButton = document.querySelector('.default-item');
//     if (!checkoutButton) return;
  
//     var totalPrice = parseInt(checkoutButton.getAttribute("data-check")) || 0;
//     console.log("totalPrice", totalPrice);
//   const button_atc = document.querySelector(".cart__checkout-button.button.atc_button");
//   console.log("button_atc",button_atc);
//     if (totalPrice < 1990) {
//         console.log("----");
//       button_atc.setAttribute("disabled",disabled);
//     } else {
//         button_atc.removeAttribute("disabled");
//     }
//   }
  
//   document.addEventListener("DOMContentLoaded", () => {
//     checkCartPrice();
//   });